import PropTypes from 'prop-types';
// @mui
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import { acceptReturnRequest } from '../store/maintenanceActions';

AcceptReturn.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  maintenanceId: PropTypes.string,
};

export default function AcceptReturn({ open, handleClose, maintenanceId }) {
  const dispatch = useDispatch();

  const { isSaving } = useSelector((state) => state.maintenanceReducer);

  const handleReturn = async () => {
    const result = await dispatch(acceptReturnRequest(maintenanceId));
    if (result?.ok) handleClose(true);
  };
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Confirmed maintenance is complete and asset is returned?'}</DialogTitle>
      <DialogActions>
        <Button size="small" variant="contained" color="error" onClick={() => handleClose(false)}>
          Cancel
        </Button>
        <LoadingButton type="submit" size="small" variant="contained" loading={isSaving} onClick={handleReturn}>
          Accept
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
